import { AuthenticationData } from '../store/authentication';
import { apiClient, ApiError } from './apiClient';

export const getOngoingApplicationService = async (
    apiKey: string,
    apiProxyPath: string,
    authenticationData?: AuthenticationData,
): Promise<string | void> => {
    try {
        const response = await apiClient<{ applicationReferenceNumber: string }>(
            `${apiProxyPath}/application/ongoing_application`,
            {
                method: 'GET',
                apiKey,
                authenticationData,
                sentryTag: 'get_ongoing_application',
                silentStatusCodes: [404],
            },
        );
        return response.applicationReferenceNumber;
    } catch (error) {
        if (error instanceof ApiError && error.statusCode === 404) {
            return;
        }
        throw error;
    }
};
